<div class="row content-container">
  <div class="col-12 col-sm-12 main-content mynovi mynovi--history">
    <div class="button-bar button-bar--justify hide-lg hide-md visible-sm">
      <a [routerLink]="['/products']">
        <strong>
          <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
          </svg>
          <span i18n="Back to products link text@@back.to.products">
            Back to products
          </span>
        </strong>
      </a>
    </div>

    <div class="button-bar button-bar--topright button-bar--mobile-block">
      <a
        (click)="startNewOrder()"
        class="button button--green theme-btn-success"
        i18n="Start a new order link text@@start.new.order.button"
        >Start a new order</a
        >
      </div>

      <h1
        class="mynovi-title"
        i18n="Order history title@@navigation.order.history"
        >
      Order history
    </h1>

      <p class="mynovi-intro" sales-person-telephone></p>

      <table class="mynovi-data-table mynovi-data-table--history">
        <thead>
          <tr>
            <th
            i18n="
              Order history header: shipping
              date@@pending.order.overview.shipping.date"
              scope="col"
              >
            Shipping date &amp; location
          </th>
            <th i18n="Order history header: volume@@order.volume" scope="col">
            Volume
          </th>
            <th
              i18n="Order history header: status@@order.history.header.status"
              scope="col"
              >
            Status
          </th>
            <th
            i18n="
              Order history header: order
              number@@order.history.header.order.number"
              scope="col"
              >
            Order nr.
          </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr class="mynovi-data-table__loading">
            <td colspan="5" i18n="@@loading.text">Loading &hellip;</td>
          </tr>
          @if (noOrders) {
            <tr class="mynovi-data-table__empty">
              <td colspan="5" i18n="@@order.history.empty">No orders in history</td>
            </tr>
          }
          @for (order of orders; track order) {
            <tr>
              <td class="mynovi-data-table_datelocation" scope="row">
                @if (order.shipmentDate) {
                  <h4>
                    {{ order.shipmentDate | customDate: "EEEE dd MMMM" }}
                  </h4>
                }
                @if (order.deliveryAddressName) {
                  <p>
                    {{ order.deliveryAddressName }}
                  </p>
                }
                @if (order.shipToCode) {
                  <p>{{ order.shipToCode }}</p>
                }
              </td>
              <td
                class="mynovi-data-table_volume"
                i18n="Calculated volume (CC)@@calculated.volume"
                >
            {{ order.volume | numberFormat: false }} CC
          </td>
              <td
                [status]="order.orderStatus"
                class="mynovi-data-table_status"
                render-history-status
              ></td>
              <td class="mynovi-data-table_orderid">
                {{ order.orderId }}
              </td>
              <td class="mynovi-data-table_buttons">
                @if (order.shipmentDate && order.shipToCode) {
                  <div
                    class="button-bar"
                    >
                    <a
                [routerLink]="[
                  '/my/order/history/detail',
                  {
                    orderId: order.orderId,
                    shipmentDate: order.shipmentDate,
                    deliveryAddressCode: order.shipToCode
                  }
                ]"
                    class="button button--secondary theme-btn-primary-outline"
                    i18n="view order link text@@view.order"
                    >
                View order
              </a>
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="button-bar button-bar--right button-bar--mobile-block">
      <a
        (click)="startNewOrder()"
        class="button button--green theme-btn-success"
        i18n="Start a new order link text@@start.new.order.button"
        >
        Start a new order
      </a>
    </div>
  </div>
</div>
